import * as React from 'react';
import * as autoBind from 'react-autobind';
import CanvasImageHelper from '../../utils/CanvasImageHelper/CanvasImageHelper';
import ImageCanvasMediaDimensionsModel from '../../types/ImageCanvasMediaDimensionsModel';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default class ImageCanvas extends React.Component<ImageCanvasProps, ImageCanvasState> {
   readonly state: ImageCanvasState = {imageLoaded: false, containerStyle: {}, canvasStyle: {}};
   private container: React.RefObject<HTMLDivElement>;
   private canvas: React.RefObject<HTMLCanvasElement>;
   private image: HTMLImageElement;

   constructor(props: ImageCanvasProps) {
      super(props);
      autoBind(this);
      this.container = React.createRef();
      this.canvas = React.createRef();
   }

   setStyling() {
      const {onDimensionsChange} = this.props;

      if (this.canvas.current && this.container.current) {
         this.setState({
            containerStyle: CanvasImageHelper.getContainerStyling(this.container.current, this.canvas.current),
            canvasStyle: CanvasImageHelper.getCanvasStyling(this.container.current, this.canvas.current)
         });

         if (this.image && onDimensionsChange) {
            onDimensionsChange({
               canvas: {
                  width: this.canvas.current.clientWidth,
                  height: this.canvas.current.clientHeight
               },
               container: {
                  width: this.container.current.clientWidth,
                  height: this.container.current.clientHeight
               },
               image: {
                  width: this.image.width,
                  height: this.image.height
               }
            });
         }
      }
   }

   drawImage() {
      const {mediaUrl} = this.props;
      this.image = new Image();

      this.image.onload = () => {
         CanvasImageHelper.setCanvasDimensionsForImage(this.canvas.current, this.image);
         CanvasImageHelper.drawImageOnCanvas(this.canvas.current, this.image);
         this.setState({imageLoaded: true});
         this.setStyling();
      };

      this.image.src = mediaUrl;
   }

   componentDidMount() {
      this.drawImage();
      window.addEventListener('resize', this.setStyling);
   }

   componentWillUnmount() {
      this.image.onload = () => ({}); // Prevent error if we unmount before image loads
      window.removeEventListener('resize', this.setStyling);
   }

   componentDidUpdate(prevProps: ImageCanvasProps) {
      if (prevProps.mediaUrl !== this.props.mediaUrl) {
         this.drawImage();
      }
   }

   render() {
      const {containerStyle, canvasStyle} = this.state;
      return (
         <div className="image-canvas-container" ref={this.container} style={containerStyle}>
            {!this.state.imageLoaded && <LoadingSpinner />}
            <canvas className="image-canvas" style={canvasStyle} ref={this.canvas}/>
         </div>
      );
   }
}

export interface ImageCanvasProps {
   mediaUrl: string;
   onDimensionsChange(dimensions: ImageCanvasMediaDimensionsModel): void;
}

export interface ImageCanvasState {
   imageLoaded: boolean;
   containerStyle: React.CSSProperties;
   canvasStyle: React.CSSProperties;
}
